module.exports = __webpack_public_path__ + "img/wind-solid.50d37bda.svg";